// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R-r-O","type":"styles_type__2bJ05","choices":"styles_choices__eCQcm"};